module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border heading-cart"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ad Spots")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "display": "inline-block",
      "width": "80%",
      "margin": "0 0 10px 10px"
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "searchFI",
      "type": "text",
      "placeholder": "search adspot by alias name (type and enter)"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterFirstImpressionTagAssociations(_vm.searchFI)
      }
    },
    model: {
      value: (_vm.searchFI),
      callback: function($$v) {
        _vm.searchFI = $$v
      },
      expression: "searchFI"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "clearSearch",
      "placement": "top"
    }
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "danger",
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearSearch()
      }
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.domain_details.buckets && _vm.domain_details.buckets[0] ?
    _vm.domain_details.buckets[0].features.indexOf('SELECTORS_AS_EXISTING') > -1 :
    false
  ) ? _c('span', {
    staticStyle: {
      "color": "red",
      "font-style": "italic",
      "background": "yellow",
      "padding": "6px",
      "margin": "5px",
      "border-radius": "3px",
      "float": "right"
    }
  }, [_vm._v("Note: For existing ad spot, selectors to be given (eg: div-gpt-30934894-1 -->\n                    #div-gpt-30934894-1)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "data": _vm.existingAdSpots,
      "height": "355",
      "stripe": "",
      "id": "assoc-table"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Alias Name",
      "width": "230",
      "prop": "alias_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.row.alias_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-dropdown', {
          staticClass: "see-usage",
          attrs: {
            "trigger": "click"
          },
          on: {
            "command": _vm.OpenAdSpotUsage
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("\n                                    See usage in bucket"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, _vm._l((_vm.domain_details.buckets), function(bucket) {
          return _c('el-dropdown-item', {
            key: bucket.id,
            attrs: {
              "command": {
                alias: props.row.alias_name,
                bucket_id: bucket.id,
                id: props.row.id,
              }
            }
          }, [(_vm.isUsed(props.row.id, bucket.id)) ? _c('i', {
            staticClass: "el-icon-success",
            staticStyle: {
              "position": "absolute",
              "left": "4px",
              "top": "12px"
            }
          }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(bucket.name) + " ")]), _vm._v(" "), (_vm.isUsed(props.row.id, bucket.id)) ? _c('span', {
            staticStyle: {
              "position": "absolute",
              "top": "50%",
              "transform": "translateY(-50%)",
              "right": "-1px"
            }
          }, [_c('el-tooltip', {
            attrs: {
              "content": "Delete all assocations on the bucket",
              "placement": "bottom"
            }
          }, [_c('button', {
            staticClass: "el-button el-button--danger el-button-small",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return _vm.deleteallTagsonBucket($event, bucket.id, props.row.id)
              }
            }
          }, [_c('i', {
            staticClass: "ti-trash",
            staticStyle: {
              "font-size": "12px",
              "padding": "3px"
            }
          })])]), _vm._v(" "), _c('el-tooltip', {
            attrs: {
              "content": "Push script for bucket",
              "placement": "bottom"
            }
          }, [_c('a', {
            staticClass: "upload",
            attrs: {
              "href": "javascript:void(0);"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.createJs(bucket.id)
              }
            }
          }, [_c('i', {
            staticClass: "el-icon-upload el-icon--right"
          })])])], 1) : _vm._e()])
        }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.checkifMoreCssPresent(props.row.ad_unit_data)) ? _c('span', {
          staticClass: "more-css"
        }, [_vm._v("\n                                MORE CSS\n                            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Existing",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.is_existing) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
          attrs: {
            "data-v-7a40f996": "",
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "far",
            "data-icon": "check-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "data-v-7a40f996": "",
            "fill": "green",
            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
          }
        })])]) : _vm._e(), _vm._v(" "), (!props.row.is_existing) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
          attrs: {
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "fal",
            "data-icon": "times-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "red",
            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
          }
        })])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Unique Id / Ad Format"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.getAdTypeName(props.row.fi_ad_type) != '-' ?
          _vm.getAdTypeName(props.row.fi_ad_type) :
          props.row.unique_id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Layout"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._l((props.row.associations), function(lay, index) {
          return (props.row.associations.length != 0) ? _c('span', {
            key: lay.id,
            staticClass: "text-capitalize"
          }, [_vm._v("\n                                " + _vm._s(lay.layout.layout_name + (index < props.row.associations.length - 1 ? ', ' : '')) + "\n                            ")]) : _vm._e()
        }), _vm._v(" "), (props.row.associations.length == 0) ? _c('span', {
          staticClass: "text-capitalize"
        }, [_vm._v("-")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "device"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "text-capitalize"
        }, [_vm._v("\n                                " + _vm._s(props.row.device) + "\n                            ")]), _vm._v(" "), (props.row.associations.length == 0) ? _c('span', {
          staticClass: "text-capitalize"
        }, [_vm._v("-")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Select",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.row.checked),
            expression: "props.row.checked"
          }],
          attrs: {
            "type": "checkbox",
            "disabled": props.row.isbucketused
          },
          domProps: {
            "checked": Array.isArray(props.row.checked) ? _vm._i(props.row.checked, null) > -1 : (props.row.checked)
          },
          on: {
            "click": function($event) {
              return _vm.checkboxChange(props.row, props.row.checked)
            },
            "change": function($event) {
              var $$a = props.row.checked,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(props.row, "checked", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(props.row, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(props.row, "checked", $$c)
              }
            }
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Delete",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('button', {
          staticClass: "el-button btn-rounded el-button--danger edit",
          attrs: {
            "type": "button",
            "disabled": props.row.isbucketused
          },
          on: {
            "click": function($event) {
              return _vm.deleteFirstImpression(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "ti-trash"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Edit",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('button', {
          staticClass: "el-button btn-rounded el-button--success edit",
          attrs: {
            "id": props.row.id
          },
          on: {
            "click": function($event) {
              return _vm.editFirstImpression(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "ti-pencil"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50, 100],
      "total": _vm.total_pages,
      "layout": "sizes, prev, pager, next",
      "page-size": _vm.offset
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "btn-rounded float-right",
    attrs: {
      "type": "danger",
      "disabled": _vm.cArr.length == 0
    },
    on: {
      "click": _vm.deleteSelectedFirstImpressions
    }
  }, [_c('i', {
    staticClass: "ti-trash"
  }), _vm._v("Delete Multiple")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveAdSpots.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Existing")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-15"
  }, [_c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.formData.existing),
      callback: function($$v) {
        _vm.$set(_vm.formData, "existing", $$v)
      },
      expression: "formData.existing"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Alias Name")]), _vm._v(" "), _c('el-input', {
    staticClass: "publisher-input",
    attrs: {
      "name": "aliasName",
      "type": "text",
      "placeholder": "Alias Name"
    },
    model: {
      value: (_vm.formData.aliasName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "aliasName", $$v)
      },
      expression: "formData.aliasName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Select device")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "input": _vm.changeValue
    },
    model: {
      value: (_vm.devicegroup),
      callback: function($$v) {
        _vm.devicegroup = $$v
      },
      expression: "devicegroup"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "mobile",
      "value": "devicegroup"
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "web",
      "value": "devicegroup"
    }
  }, [_vm._v("Web")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "tablet",
      "value": "devicegroup"
    }
  }, [_vm._v("Tablet")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "all",
      "value": "devicegroup"
    }
  }, [_vm._v("All")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.existing),
      expression: "formData.existing"
    }],
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Unique")]), _vm._v(" "), _c('el-input', {
    staticClass: "publisher-input",
    attrs: {
      "name": "udivid",
      "type": "text",
      "placeholder": "Unique div id"
    },
    model: {
      value: (_vm.formData.udivid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "udivid", $$v)
      },
      expression: "formData.udivid"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formData.existing),
      expression: "!formData.existing"
    }],
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Select Ad Format")]), _vm._v(" "), _c('el-select', {
    staticClass: "select-input",
    attrs: {
      "filterable": "",
      "placeholder": "Choose ad format"
    },
    on: {
      "change": function($event) {
        return _vm.getAdFormatFields()
      }
    },
    model: {
      value: (_vm.formData.fiAdType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fiAdType", $$v)
      },
      expression: "formData.fiAdType"
    }
  }, _vm._l((_vm.fiAdTypes), function(fiAdType) {
    return _c('el-option', {
      key: fiAdType.id,
      attrs: {
        "label": fiAdType.name,
        "value": fiAdType.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Layout")]), _vm._v(" "), _c('el-select', {
    staticClass: "publisher-input select-input",
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "filterable": "",
      "placeholder": "Select layout"
    },
    on: {
      "change": function($event) {
        return _vm.selectLayoutEdit(_vm.formData)
      },
      "remove-tag": function($event) {
        return _vm.layoutTagRemoved(_vm.formData)
      }
    },
    model: {
      value: (_vm.formData.adspotLayout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "adspotLayout", $$v)
      },
      expression: "formData.adspotLayout"
    }
  }, _vm._l((_vm.existingLayouts), function(layout) {
    return _c('el-option', {
      key: layout.id,
      attrs: {
        "label": layout.layout_name,
        "value": layout.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Def. Slot")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-15"
  }, [_c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.formData.defineSlot),
      callback: function($$v) {
        _vm.$set(_vm.formData, "defineSlot", $$v)
      },
      expression: "formData.defineSlot"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formData.existing),
      expression: "!formData.existing"
    }],
    staticClass: "row clearfix"
  }, _vm._l((_vm.adFormatFields), function(field) {
    return _c('div', {
      key: field.name,
      staticClass: "col-md-4 m-t-15"
    }, [_c('p', {
      staticClass: "form-label"
    }, [_vm._v("\n                                " + _vm._s(field.display_name) + "\n                            ")]), _vm._v(" "), (field.type == 'text') ? _c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": field.display_name,
        "id": field.display_name
      },
      model: {
        value: (_vm.formData.adTypeData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData.adTypeData, field.name, $$v)
        },
        expression: "formData.adTypeData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type == 'number') ? _c('el-input', {
      attrs: {
        "type": "number",
        "id": field.display_name,
        "step": "0.01"
      },
      model: {
        value: (_vm.formData.adTypeData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData.adTypeData, field.name, _vm._n($$v))
        },
        expression: "formData.adTypeData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type == 'checkbox') ? _c('div', {
      staticClass: "clearfix m-t-15 m-b-13"
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-color": "#ff4949",
        "for": field.display_name,
        "active-text": "Active",
        "inactive-text": "Inactive"
      },
      model: {
        value: (_vm.formData.adTypeData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData.adTypeData, field.name, $$v)
        },
        expression: "formData.adTypeData[field.name]"
      }
    })], 1) : _vm._e(), _vm._v(" "), (field.type == 'radio') ? _c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.formData.adTypeData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData.adTypeData, field.name, $$v)
        },
        expression: "formData.adTypeData[field.name]"
      }
    }, _vm._l((field.values), function(val) {
      return _c('el-radio-button', {
        key: val.value,
        attrs: {
          "label": val.value
        }
      }, [_vm._v(_vm._s(val.display_name))])
    }), 1) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15 clearfix text-right"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.editId),
      expression: "formData.editId"
    }],
    staticClass: "el-button el-button--danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearForm()
      }
    }
  }, [_vm._v("\n                                Cancel\n                            ")]), _vm._v(" "), _c('button', {
    ref: "changesSubmit",
    staticClass: "el-button el-button--success",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableCheck(_vm.formData)
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.formData.editId ? 'Update' : 'Save') + "\n                            ")])])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59eea1a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/first-impression/FiSetupAdSpots.vue
// module id = 689
// module chunks = 2